module.exports = __webpack_public_path__ + "static/media/science_text_us.71436551.png";